import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { Membership } from './membership.model';

@Injectable({ providedIn: 'root' })
export class MembershipService {
  apiHost: string = environment.apiHost;
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getMembershipRequests(): Promise<Membership[]> {
    let promise = new Promise<Membership[]>((resolve, reject) => {
      return this.http
        .get<Membership[]>(this.apiHost + '/membership/pullrequests')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Membership Requests', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  acceptUser(userId: string): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(
          this.apiHost + '/Membership/ApproveByUser?userId=' + userId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Accept Membership', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  denyUser(userId: string): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(
          this.apiHost + '/Membership/DenyByUser?userId=' + userId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Deny Membership', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
